import React, { useEffect, useState } from 'react';
import rentItems from '../assets/rentItems';
import Navigation from '../components/Navigation';
import { useParams } from 'react-router-dom';
import RentSaleProperty from '../components/RentSaleComponents/RentSaleProperty';
import Footer from '../components/Footer';

function RentProject() {

  const {id} = useParams();
  const [rentProject, setRentProject] = useState(null);

  useEffect(() => {

    let rentProject = rentItems.find(rentProject => rentProject.id === parseInt(id));

    if (rentProject) {
      setRentProject(rentProject);
    }
  }, [id])

  return (
    <div className='App'>
        <Navigation />
        {
          rentProject ? (
            <RentSaleProperty propertyAddress={rentProject.address} propertyImage={rentProject.image1} propertyImages={rentProject.images} propertyPrice={rentProject.price} propertyLongDescription={rentProject.longDescription} propertyBedrooms={rentProject.bedrooms} propertyBathrooms={rentProject.bathrooms} propertyLivingrooms={rentProject.livingrooms} />
          ) : (
            null
          )
        }
        <Footer />
    </div>
  )
}

export default RentProject;
